import { Navigate, useLocation } from 'react-router-dom'

import { AuthLoading } from '@/components/auth/AuthLoading'
import { useAuth } from '@/contexts/AuthContext'

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return <AuthLoading />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}
